import { type OperationId, operationIds } from "@gen/app-access-config";
import { CoreQuery } from "@gen/app-query";
import Button from "@mui/material/Button";
import { useQueryClient } from "@tanstack/react-query";

interface ConfirmDeliveryActionProps {
  canExecuteForStatus: (operationId: OperationId) => boolean;
  transactionId: number;
}

export function ConfirmOnlineDelivery({
  canExecuteForStatus,
  transactionId,
}: ConfirmDeliveryActionProps) {
  const queryClient = useQueryClient();
  const {
    mutate: confirmOnlineDelivery,
    isPending: isConfirmingOnlineDelivery,
  } = CoreQuery.useAdmin_confirmOnlineDeliveryMutation(transactionId, {
    meta: {
      success: `Delivery confirmed`,
    },
    onSuccess: () => {
      if (transactionId) {
        queryClient.invalidateQueries({
          queryKey: CoreQuery.admin_getOnlineTransactionQueryKey(transactionId),
        });
      }
    },
  });

  if (!canExecuteForStatus(operationIds["core_admin.confirmOnlineDelivery"])) {
    return null;
  }

  const onSubmit = () => {
    confirmOnlineDelivery({});
  };

  return (
    <Button
      variant="contained"
      loading={isConfirmingOnlineDelivery}
      size="large"
      fullWidth
      onClick={onSubmit}
      data-testid="confirm-delivery-button"
    >
      Confirm delivery
    </Button>
  );
}

export function ConfirmF2fDelivery({
  canExecuteForStatus,
  transactionId,
}: ConfirmDeliveryActionProps) {
  const queryClient = useQueryClient();
  const { mutate: confirmF2fDelivery, isPending: isConfirmingF2fDelivery } =
    CoreQuery.useAdmin_confirmF2fDeliveryMutation(transactionId, {
      meta: {
        success: `Delivery confirmed`,
      },
      onSuccess: () => {
        if (transactionId) {
          queryClient.invalidateQueries({
            queryKey: CoreQuery.admin_getF2fTransactionQueryKey(transactionId),
          });
        }
      },
    });

  if (!canExecuteForStatus(operationIds["core_admin.confirmF2fDelivery"])) {
    return null;
  }

  const onSubmit = () => {
    confirmF2fDelivery({});
  };

  return (
    <Button
      variant="contained"
      loading={isConfirmingF2fDelivery}
      size="large"
      fullWidth
      onClick={onSubmit}
      data-testid="confirm-delivery-button"
    >
      Confirm delivery
    </Button>
  );
}
